import React from 'react';
import { Grid, Table, TableBody, TableCell, TableRow } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Skeleton } from '@mui/material';
import { InstalledCollectorHeader } from './InstalledCollectorHeader';

const useStyles = makeStyles((theme) => ({
  grid: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  },
  tableRow: {
    '& >td': {
      paddingLeft: theme.spacing(0),
      border: 'none'
    },
    '& > td:last-child': {
      paddingLeft: theme.spacing(1.5)
    }
  },
  skeleton: {
    background: theme.skelton?.color,
    borderRadius: theme.spacing(0.5)
  }
}));

export const InstalledCollectorsPageSkeleton: React.FC = () => {
  const classes = useStyles();
  return (
    <Grid
      container
      spacing={1}
      className={classes.grid}
      data-testid="installed-collectors-page-skeleton"
    >
      <Table size="small">
        <InstalledCollectorHeader />
        <TableBody>
          {Array.from(new Array(5)).map((item, index) => {
            return (
              <TableRow
                data-testid={'installed-collectors-list-skeleton'}
                className={classes.tableRow}
                key={index}
              >
                <TableCell>
                  <Skeleton
                    className={classes.skeleton}
                    height={25}
                    width="85%"
                    variant="rectangular"
                  />
                </TableCell>
                <TableCell>
                  <Skeleton
                    className={classes.skeleton}
                    height={25}
                    width="55%"
                    variant="rectangular"
                  />
                </TableCell>
                <TableCell>
                  <Skeleton
                    className={classes.skeleton}
                    height={25}
                    width="75%"
                    variant="rectangular"
                  />
                </TableCell>
                <TableCell>
                  <Skeleton
                    className={classes.skeleton}
                    height={25}
                    width="65%"
                    variant="rectangular"
                  />
                </TableCell>
                <TableCell>
                  <Skeleton
                    className={classes.skeleton}
                    height={25}
                    width="65%"
                    variant="rectangular"
                  />
                </TableCell>
                <TableCell>
                  <Skeleton
                    className={classes.skeleton}
                    height={25}
                    width="75%"
                    variant="rectangular"
                  />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Grid>
  );
};
